

import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { Button, Table, message } from "antd";
import monthPickerHoc from "@/hoc/form/monthPickerHoc";
const defaultDate = moment();
import ExportJsonExcel from 'js-export-excel';

@monthPickerHoc
class ErrorTop10 extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      gridData: [],
      dataSource:[],
      pType:0,
      columns:[]
    };

    
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
  }

  componentWillReceiveProps(nextProps) {
    console.info('进入')
    console.info(nextProps)
    this.setState(
      {
        gridData: nextProps.param == null ? [] : nextProps.param,
      }
    );
    var dataSource = [];
    var columns = [];
      if (nextProps.param && nextProps.param != null)
      {
        dataSource = nextProps.param;
      }
    columns = [
        {
          title: '排名',
          dataIndex: 'rankNum',
          key: 'rankNum',
          width: 100
        },
        {
          title: '地区',
          dataIndex: 'cityName',
          key: 'cityName',
          width: 100
        },
        {
          title: '故障率',
          dataIndex: 'rate',
          key: 'rate',
          width: 100
        }
      ];
   
        this.setState(
          {
            columns:columns,
            dataSource:dataSource
          }
        )
  }

    static contextTypes = {
      store: PropTypes.object.isRequired,
    }

    componentWillMount() {
    }


    fetchApi = (params) => {
      let result = {
        ...params,
      };
      if (params.month) {
        result = {
          ...result,
          month: params.month.format("YYYYMM"),
        };
      }
      return result;
    };

    getCaptcha = () => {
      if (!this.state.dataSource || this.state.dataSource == null || this.state.dataSource.length  == 0)
      {
        message.error("暂无数据");
        return;
      }
    var data = this.state.dataSource ? this.state.dataSource : '';//表格数据
      var option={};
      let dataTable = [];
      if (data) {
        for (let i in data) {
          if(data){
            let obj = {}
            for (let j in this.state.columns)
            {
              obj[this.state.columns[j].title] = data[i][this.state.columns[j].dataIndex];
              
            }
            dataTable.push(obj);
          }
        }
      }
      var header = [];
      for (var i=0; i<this.state.columns.length; i++)
      {
        header.push(this.state.columns[i].title);
      }
      option.fileName = '人效指标'
      option.datas=[
        {
          sheetData:dataTable,
          sheetName:'sheet',
          sheetFilter:header,
          sheetHeader:header,
        }
      ];

      var toExcel = new ExportJsonExcel(option); 
      toExcel.saveExcel(); 
    };

    render() {
      const columns = this.state.columns;
      const dataSource = this.state.dataSource;
      const content = (
        <div>
          
        <div className="board-inner"
        style={{ height: "100%", display: "flex", flexDirection: "column", marginTop: "15px", overflowY:"scroll", overflow: "auto !important", position:"absolute", width:"95%" }}>
          <div className="page-panel">
            {/* <ScGridTable config={this.state.tableConfig} /> */}

            <Table dataSource={dataSource} columns={columns}  pagination={{ position: ['top', 'None'], pageSize:dataSource == null || dataSource.length == 0 ? 10 : dataSource.length }}/>
          </div>
        </div>
        </div>
      );
      return (
        content)
    }
}

export default ErrorTop10;



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/errorTop10.js